import styled from 'styled-components';
import { Expander as VendorExpander } from 'app/components';
import { textTransform } from 'utils';

export const PortraitWrapper = styled.div.attrs({
  className: 'portrait'
})`
  h2 {
    font-weight: 450;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
  }

  .portrait__carousel-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 36px;

    .portrait__carousel {
      width: 952px;
      height: 360px;

      .portrait__carousel-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .portrait__description {
    margin-top: 60px;
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
  }
  .portrait__description a{
    color:#DE1619;
    text-decoration:underline;
  }
  .portrait__item {
    margin-top: 60px;
    h3 {
      font-weight: 450;
      font-size: 20px;
      line-height: 24px;
      color: #de1619;
    }

    .portrait__item-image {
      margin-top: 20px;
      height: 320px;
      width: 100%;
    }

    .portrait__description {
      margin-top: 24px;
    }

    &:last-child {
      margin-bottom: 35px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    .portrait__carousel-wrapper {
      width: 100%;
      .portrait__carousel {
        width: 100%;
        height: 230px;
      }
    } 
    .portrait__item {
      .portrait__item-image {
        height: auto;
        width: 100%;
      }
    }
  }
`;

export const Title = styled.h1`
  display: inline-block;
  vertical-align: middle;
  font-size: 2.4rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.textPrimary};
  margin: 29px 0 30px 0;
`;

export const Expander = styled(VendorExpander)`
  background: #2d2d2d;
  padding: 0 16px;

  ul {
    margin: 10px 0;
    & > li {
      margin-top: 24px;
      width: 100%;

      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        text-transform: ${textTransform};
      }

      a {
        margin-top: 9px;
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #de1619;
      }
    }
    & > li:first-child {
      margin-top: 0;
    }
  }
`;
